$(document).ready(function () {
    let auto_click_term = $('#auto_click_term');
    if (auto_click_term.length) {
        $('.js-select-term[data-term="' + auto_click_term.val() + '"]').trigger('click');
    }
})

$(document).on('click', '.js-copy-url-to-register-return-url', function () {
    $('.js-register-return-url').val(window.location.href);
});

function ajax_calculate_variable_price(active_cell, selected_service, service_time, time_till, is_regular = false) {

    let modal_variable_price = $('.js-modal-service-price');
    modal_variable_price.html('<img class="loader" src="' + LOADER + '" alt="ajax loader">');

    if (!is_regular) {
        var basket_button = $('.reservation-modal button.add_to_cart_button');
        basket_button.attr('disabled', 'disabled');
    }

    jQuery.post(
        BASE_URL + '/wp-admin/admin-ajax.php',
        {
            action: 'calculate_variable_service_price',
            zariadenie_id: $('#zariadenie_id').val(),
            service_length: selected_service.data('service-length'),
            time_from: service_time,
            time_to: time_till,
            weekday: active_cell.data('weekday'),
            is_regular: is_regular ? 1 : 0,
        },
        function (response) {
            response = JSON.parse(response);

            if (response.success) {

                if(response.price){
                    modal_variable_price.html(response.price);
                    $('#variable_selected_product_id').val(response.product_id);

                    if (!is_regular) {
                        basket_button.removeAttr('disabled');
                    }

                }else{
                    notif('danger', 'Takáto kombinácia neexistuje. Kontaktujte prosím administrátora.');
                }


            } else {
                notif('danger', 'Nepodarilo sa získať cenu za službu');
            }
        }
    )
}


/*
$('.reservation-table').on( 'mouseleave', function(){
    $('th.hovered', $(this)).removeClass('hovered');
} );

$('.reservation-table th, .reservation-table .disabled').hover(function(){
    $('.reservation-table th.hovered').removeClass('hovered');
});
*/

$('.js-select-table-service').change(function () {
    $('.js-term-type').fadeIn();

    let select_term_types = $('.js-select-term');

    /* select term type when only one is available */
    if(select_term_types.length === 1){
        select_term_types.first().addClass('active');
    }

    let active_term_type = $('.js-select-term.active');

    if (active_term_type.length) {
        let term_type = active_term_type.data('term');
        let week = 0;

        if (term_type === 'one-time') {
            week = get_get_param('week');
        }

        get_table_calendar_html(term_type, week);
    }
    add_get_param_to_url('service', $(this).val());
})

$(document).on('click', '.js-select-term:not(.active)', function () {
    $('.js-select-term.active').removeClass('active');
    $(this).addClass('active');

    let term_type = $(this).data('term');
    let week = 0;

    if (term_type == 'one-time') {
        week = get_get_param('week');
    } else {
        remove_get_param_from_url('week');
    }

    get_table_calendar_html(term_type, week);
    add_get_param_to_url('term-type', term_type);
})

$(document).on('click', '.js-one-time-calendar-move:not(.disabled)', function () {
    let week = $(this).data('week');
    if (week === 0) {
        $('.js-one-time-calendar-this-week').addClass('disabled');
    } else {
        $('.js-one-time-calendar-this-week').removeClass('disabled');
    }

    get_one_time_calendar(week);
})

$(document).on('click', '.js-one-time-calendar-this-week:not(.disabled)', function () {
    get_one_time_calendar(0);
});

function get_one_time_calendar(week) {
    let term_type = $('.js-select-term.active').data('term');
    get_table_calendar_html(term_type, week);
    add_get_param_to_url('term-type', term_type);
    add_get_param_to_url('week', week);
}


function get_table_calendar_html(term_type = false, week = 0) {
    if (!term_type) {
        term_type = $('.js-select-term.active').data('term');
    }
    let zariadenie_id = $('#zariadenie_id').val();
    let service_id = $('.js-select-table-service:checked').data('service-id');
    let service_length = $('.js-select-table-service:checked').data('service-length');
    let action = '';
    let reservation_type = $('#reservation_type').val();

    if (term_type === 'one-time') {
        action = 'get_table_one_time_calendar_html';
    } else if (term_type === 'regular') {
        action = 'get_table_regular_calendar_html';
    }

    let data_to_send = {
        action: action,
        zariadenie_id: zariadenie_id,
        service_id: service_id,
        service_length: service_length,
        reservation_type: reservation_type,
        week: week
    };

    jQuery.post(BASE_URL + '/wp-admin/admin-ajax.php', data_to_send, function (response) {
        if (response) {
            $('.js-calendar-wrapper').html(response);
        }
    })
}

$(document).on('mouseenter', '.js-table-cell-reserve, .js-table-cell-regular-reserve', function() {
    const index = $(this).index();
    $('.reservation-table-simple thead th').eq(index).addClass('highlighted');
});

$(document).on('mouseleave', '.js-table-cell-reserve, .js-table-cell-regular-reserve', function() {
    const index = $(this).index();
    $('.reservation-table-simple thead th').eq(index).removeClass('highlighted');
});

$(document).on('click', '.js-table-cell-reserve', function () {

    let active_cell = $(this);
    $('.js-table-cell-reserve.active').removeClass('active');
    $(this).addClass('active');

    let modal = $('.reservation-modal');
    modal.addClass('loading');
    modal_open(modal);

    let selected_service = $('.js-select-table-service:checked');
    let service_time = active_cell.data('time');
    let time_till = calculate_time_till(service_time, selected_service.data('service-length'));
    let has_variable_service = selected_service.data('has-variable-price');
    let has_cross_sell = $('.js-reservation-cross-sell-wrapper').length;

    $('.js-modal-service-name').text(selected_service.next('.service-name').text());
    $('.js-modal-date').html(active_cell.data('date'));
    $('.js-modal-part').html(active_cell.data('part-title') + ' ' + active_cell.data('part-help-text'));
    $('.js-modal-time').html(service_time);
    $('.js-modal-time-till').text(time_till);
    $('.js-modal-day-name').html(active_cell.data('day-name'));

    if (has_variable_service) {
        ajax_calculate_variable_price(active_cell, selected_service, service_time, time_till);
    } else {
        $('.js-modal-service-price').html(selected_service.data('service-price'));
        $('.add_to_cart_button').removeAttr('disabled');
    }

    if(has_cross_sell){
        get_cross_sell_html(selected_service, active_cell.data('date'), service_time, time_till);
    }

    modal.removeClass('loading');
});

function get_cross_sell_html(selected_service, date, service_time, time_till){
    jQuery.post(
        BASE_URL + '/wp-admin/admin-ajax.php',
        {
            action: 'get_cross_sell_html',
            zariadenie_id: $('#zariadenie_id').val(),
            service_length: selected_service.data('service-length'),
            date: date,
            time_from: service_time,
        },
        function (response) {
            if(response){
                $('.js-reservation-cross-sell-wrapper').html(response);
            }
        }
    )
}

$(document).on('click', '.js-table-cell-regular-reserve', function () {
    let active_cell = $(this);
    $('.js-table-cell-regular-reserve.active').removeClass('active');
    active_cell.addClass('active');

    let modal = $('.reservation-modal');
    modal.addClass('loading');
    modal_open(modal);

    let selected_service = $('.js-select-table-service:checked');
    let service_time = active_cell.data('time');
    let has_variable_service = selected_service.data('has-variable-price');
    let service_regular_price = selected_service.data('service-regular-price');

    $('.js-modal-service-name').text(selected_service.next('.service-name').text());
    $('.js-modal-date').html(active_cell.data('date'));
    $('.js-modal-part').html(active_cell.data('part-title') + ' ' + active_cell.data('part-help-text'));
    $('.js-modal-time').html(service_time);
    $('.js-modal-day-name').html(active_cell.data('day-name'));
    $('.js-show-on-regular').show();

    $('.js-modal-next-available-date').text('');
    let time_till = calculate_time_till(service_time, selected_service.data('service-length'));
    $('.js-modal-time-till').text(time_till);

    get_table_regular_possible_terms(0, active_cell, selected_service, modal);

    if (has_variable_service) {
        ajax_calculate_variable_price(active_cell, selected_service, service_time, time_till, true);
    } else {

        /* TODO: if regular discount, show discount */
        if(service_regular_price){
            $('.js-modal-service-price').html(service_regular_price);
        }else{
            $('.js-modal-service-price').html(selected_service.data('service-price'));
        }
    }
})

function get_table_regular_possible_terms(number_of_terms, active_cell = false, selected_service = false, modal = false, regular_hash = false) {

    if (!active_cell) {
        active_cell = $('.js-table-cell-regular-reserve.active');
    }
    if (!modal) {
        modal = $('.reservation-modal');
    }
    if (!selected_service) {
        selected_service = $('.js-select-table-service:checked');
    }

    $('.js-modal-regular-terms', modal).addClass('loading');

    let data_to_send = {
        action: 'get_table_regular_possible_terms',
        zariadenie_id: $('#zariadenie_id').val(),
        time: active_cell.data('time'),
        weekday: active_cell.data('weekday'),
        service_length: selected_service.data('service-length'),
        part_id: active_cell.data('part'),
        is_ajax_call: true,
        number_of_terms: number_of_terms,
        regular_hash: $('.regular-terms-controller').data('regular-hash')
    };

    jQuery.post(BASE_URL + '/wp-admin/admin-ajax.php', data_to_send, function (response) {
        response = JSON.parse(response);

        if (!response) {
            notif('danger', $('#time_is_not_available').val());
            modal_close();
            get_table_calendar_html(); // reinit table
        } else {

            if (response.allow_add_to_cart) {
                $('.add_to_cart_button').removeAttr('disabled');
            } else {
                $('.add_to_cart_button').attr('disabled', 'disabled');
            }

            $('.js-modal-regular-terms').html(response.regular_terms_html);

            if (response.hide_regular_alert) {
                $('.js-alert-minimum-4-terms').hide();
            } else {
                $('.js-alert-minimum-4-terms').show();
            }

            if (response.shutdown_alert_html) {
                $('.js-alert-shutdown').html(response.shutdown_alert_html).show();
            } else {
                $('.js-alert-shutdown').hide();
            }

            modal.removeClass('loading');
            $('.js-modal-regular-terms', modal).removeClass('loading');
        }
    })
}

$(document).on('submit', '.js-add-table-reservation-to-cart-form', function (e) {
    e.preventDefault();

    let selected_service = $('.js-select-table-service:checked');
    let active_cell = $('.time-cell.active');
    let term_type = $('.js-select-term.active').data('term');
    let is_regular = term_type === 'regular' ? 1 : 0;
    let date = false;
    let service_id = false;
    let has_variable_price = selected_service.data('has-variable-price');

    let dates = [];
    /* date pri regular sa generuje cez nearest_possible */
    if (is_regular) {
        dates = get_regular_dates_from_modal_list();
    } else {
        date = active_cell.data('date');
    }

    if (has_variable_price) {
        service_id = $('#variable_selected_product_id').val();
    } else {
        if(is_regular) {
            let service_regular_product_id = selected_service.data('service-regular-product-id');
            if (service_regular_product_id) {
                service_id = selected_service.data('service-regular-product-id');
            } else {
                service_id = selected_service.data('service-id');
            }
        }else{
            service_id = selected_service.data('service-id');
        }
    }

    let week = 0;

    if (!is_regular) {
        week = get_get_param('week');
    }

    jQuery.post(
        BASE_URL + '/wp-admin/admin-ajax.php',
        {
            action: 'add_table_calendar_service_to_cart',
            object_id: $('#zariadenie_id').val(),
            service_id: service_id,
            service_length: selected_service.data('service-length'),
            date: date,
            weekday: active_cell.data('weekday'),
            part_id: active_cell.data('part'),
            part_title: active_cell.data('part-title'),
            part_text: $('#part_text').val(),
            time: active_cell.data('time'),
            is_regular: is_regular,
            dates: is_regular ? dates : null,
            cross_sell: $('input[name="cross_sell_reservation"]:checked').val()
        },
        function (response) {
            response = JSON.parse(response);

            if (response.success) {
                notif('success', $('#service_added_to_cart_text').val());
                refresh_header(response.header);
                /* reinit table */
                get_table_calendar_html(term_type, week);
                modal_close();
            } else {
                if (response.notif) {
                    notif('danger', response.notif);

                    if (is_regular) {
                        get_table_regular_possible_terms($('.js-number-of-regular-terms').val());
                    }

                } else {
                    notif('danger', $('#time_is_not_available').val());
                    /* reinit table */
                    get_table_calendar_html(term_type, week);
                    modal_close();
                }
            }
        }
    )
    return false;
});

var term_input_timeout;

$(document).on('click', '.js-regular-terms-change:not(.disabled)', function () {

    clearTimeout(term_input_timeout);

    let type = $(this).data('type');

    let input = $('.js-number-of-regular-terms');

    let number = input.val();

    if (type) {
        number++;
        $('.js-regular-terms-change[data-type="0"]').removeClass('disabled');
    } else {
        number--;
        $('.js-regular-terms-change[data-type="1"]').removeClass('disabled');
    }

    if (number > input.attr('max')) {
        number = input.attr('max');
        $(this).addClass('disabled');
    } else if (number < input.attr('min')) {
        number = input.attr('min');
        $(this).addClass('disabled');
    }

    input.val(number);

    term_input_timeout = setTimeout(function () {
        get_table_regular_possible_terms(number);
    }, 500);
});


$(document).on('input', '.js-number-of-regular-terms', function () {
    clearTimeout(term_input_timeout);

    let input = $(this);
    let value = input.val().replace(/[^0-9\.]/g, '');
    let number = parseFloat(value);
    //
    // let min = parseFloat(input.attr('min'));
    // let max = parseFloat(input.attr('max'));
    //
    // if (isNaN(number)) {
    //     input.val(min);
    //     number = min;
    // }
    //
    // if (number < max) {
    //     $('.js-regular-terms-change[data-type="1"]').removeClass('disabled');
    // }
    //
    // if (number > min) {
    //     $('.js-regular-terms-change[data-type="0"]').removeClass('disabled');
    // }
    //
    // if (number > max) {
    //     number = max;
    //     $('.js-regular-terms-change[data-type="1"]').addClass('disabled');
    // } else if (number < min) {
    //     number = min;
    //     $('.js-regular-terms-change[data-type="0"]').addClass('disabled');
    // }

    term_input_timeout = setTimeout(function () {
        get_table_regular_possible_terms(number, false, false, false);
    }, 500);
});

// $.fn.isInViewport = function (offset_top = 0, offset_bottom = 0) {
//     let elementTop = $(this).offset().top;
//     let elementBottom = elementTop + $(this).outerHeight();
//
//     let viewportTop = $(window).scrollTop();
//     let viewportBottom = viewportTop + $(window).height();
//
//     return elementBottom + offset_bottom > viewportTop && elementTop + offset_top < viewportBottom;
// };

if($('body').hasClass('post-type-zariadenia')){

    if($(window).width() < 768){

        document.addEventListener('scroll', function (event) {
            let target = $(event.target);

            if (target.hasClass('table-calendar-wrapper')) {
                $('.js-fixed-calendar-head').scrollLeft( $(event.target).scrollLeft() );
            }
            if (target.hasClass('js-fixed-calendar-head')) {
                $('.table-calendar-wrapper').scrollLeft( $(event.target).scrollLeft() );
            }

            // Skontrolujeme, či sa elementy nachádzajú vo viewporte alebo nie
            // let reservation_table = $('.reservation-table');
            // let before_reservation_table = $('.js-table-calendar-wrapper');

            // if (reservation_table.length && before_reservation_table.length) { // Skontrolujeme, či existujú v DOMe
            //     if (reservation_table.isInViewport(0, -150) && !before_reservation_table.isInViewport()) {
            //
            //         let thead = $('.reservation-table-thead');
            //
            //         reservation_table.addClass('fixed-head');
            //
            //         thead.scrollLeft($('.table-calendar-wrapper').scrollLeft());
            //     } else {
            //         reservation_table.removeClass('fixed-head');
            //         $('.js-table-calendar-wrapper').css('padding-top', 0);
            //     }
            // }
        }, true);

    }
}

if($('.js-calendar-wrapper').length){
    // Skontrolovať viditeľnosť pri načítaní stránky a pri scrollovaní
    checkVisibility();
    $(window).on('scroll resize', checkVisibility);

    /*
    // Nastaví šírky stĺpcov v hlavičke na základe šírok stĺpcov v tele
    function setHeaderColumnWidths() {
        let $headerTable = $('.reservation-table thead tr.fixed-calendar-head');
        let $contentTable = $('.reservation-table tbody');

        const $headerCells = $headerTable.find('th');
        const $contentCells = $contentTable.find('tr').first().children();

        $headerCells.each(function(index) {
            const contentCellWidth = $contentCells.eq(index + 1).outerWidth();
            $(this).css('min-width', contentCellWidth + 'px');
        });
    }

    // Volaj funkciu po načítaní stránky a pri zmene veľkosti okna
    // setHeaderColumnWidths();
    // $(window).on('resize', setHeaderColumnWidths);
    */
}


function checkVisibility() {

    let reservations_table = $('.js-table-calendar-wrapper');

    if(!reservations_table.length){
        return;
    }

    const windowTop = $(window).scrollTop();
    const windowBottom = windowTop + $(window).height();
    const elementTop = reservations_table.offset().top;
    const elementBottom = elementTop + reservations_table.outerHeight();

    if (windowTop > elementTop && windowBottom < (elementBottom + 650)) {
        $('.fixed-calendar-head', reservations_table).addClass('active');
    } else {
        $('.fixed-calendar-head', reservations_table).removeClass('active');
    }
}


// $(document).on( 'scroll', '.table-calendar-wrapper', function() {
//     $('.js-fixed-calendar-head').scrollLeft($(this).scrollLeft());
// });
//
// $('.js-fixed-calendar-head').on('scroll', function() {
//     $('.table-calendar-wrapper').scrollLeft($(this).scrollLeft());
// });
